import { canonicalToLegacyEventLog, validateCanonicalDataset } from '@canonical-process';

export function canonicalDatasetToProcessAdvisorRows(dataset, { validate = true } = {}) {
  if (validate) {
    const result = validateCanonicalDataset(dataset);
    if (!result.valid) {
      throw new Error(`Invalid canonical process dataset: ${result.errors.join('; ')}`);
    }
  }
  return canonicalToLegacyEventLog(dataset);
}

export function isCanonicalProcessDataset(value) {
  return Boolean(value && typeof value === 'object' && value.schemaVersion && Array.isArray(value.events) && Array.isArray(value.cases));
}
